import { render } from "./StudioData.vue?vue&type=template&id=6b76801e"
import script from "./StudioData.vue?vue&type=script&lang=js"
export * from "./StudioData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__